import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      
      <p>&copy; 2024 Snow Kone Factory. All rights reserved</p>
    </footer>
  );
};

export default Footer;